module.exports = __webpack_public_path__ + "static/media/viber.509feb78.svg";